import { gql } from 'apollo-angular';

export const CREATE_QUOTE_WORK_SPLIT = gql`
  mutation bulkCreateQuotesWork(
    $createQuotesWorkInputs: [CreateQuotesWorkInput!]!
  ) {
    bulkCreateQuotesWork(createQuotesWorkInputs: $createQuotesWorkInputs) {
      id
      branchCode
      quoteId
      description
      amount
    }
  }
`;

export const BULK_CREATE_QUOTE = gql`
  mutation bulkCreateQuote(
    $projectId: Int!
    $partnerId: Int!
    $quote: String!
    $requirement: String!
    $TRN: String!
    $SOW: String!
    $description: String!
    $unit: String!
    $price: Float!
    $vat: Float!
    $total: Float!
    $workOrder: String!
    $startDate: String!
    $endDate: String!
  ) {
    bulkCreateQuote(
      projectId: $projectId
      partnerId: $partnerId
      quote: $quote
      requirement: $requirement
      TRN: $TRN
      SOW: $SOW
      description: $description
      unit: $unit
      price: $price
      vat: $vat
      total: $total
      workOrder: $workOrder
      startDate: $startDate
      endDate: $endDate
    )
  }
`;

export const UPDATE_QUOTE_WORK_SPLIT = gql`
  mutation bulkUpdateQuotesWork(
    $updateQuotesWorkInputs: [UpdateQuotesWorkInput!]!
  ) {
    bulkUpdateQuotesWork(updateQuotesWorkInputs: $updateQuotesWorkInputs) {
      id
      branchCode
      quoteId
      description
      amount
    }
  }
`;

export const FINALIZE_QUOTE = gql`
  mutation finalizeQuote(
    $quoteId: Int!
    $quoteItemsInput: [CreateQuoteItemInput!]
    $quoteExclusionInput: [CreateQuoteExclusionInput!]
    $quoteAttachmentsInput: [CreateQuoteAttachmentInput!]
  ) {
    finalizeQuote(
      quoteId: $quoteId
      quoteItemsInput: $quoteItemsInput
      quoteExclusionInput: $quoteExclusionInput
      quoteAttachmentsInput: $quoteAttachmentsInput
    ) {
      id
      parentQuoteId
      quoteCode
      partnerId
      TRN
      SOW
      quoteDate
      expiryDate
      approvalDate
      createdBy
      branchId
      billingAddressId
      refNumber
      projectId
      newProjectName
      quoteTitle
      subject
      subTotal
      tax
      adjustment
      totalAmount
      paymentTerm
      deliveryTerm
      validity
      termsCondition
      customerNote
      additionalNote
      quoteUrl
      status
      createdAt
      updatedAt
      deletedAt
      baseCode
      revisionNumber
      variationNumber
      archivedVersion
      quoteType
    }
  }
`;

export const CREATE_QUOTATION = gql`
  mutation createQuote(
    $createQuoteInput: CreateQuoteInput!
    $items: [CreateQuoteItemWithTasksInput]
  ) {
    createQuote(createQuoteInput: $createQuoteInput, items: $items) {
      id
      subTotal
      tax
      discount
      totalAmount
      quoteStatus
      discountType
      discountValue
      discountReason
      isDiscountApproved
      paymentTerms
      approvalDate
      status
      notes
    }
  }
`;

export const UPDATE_QUOTATION = gql`
  mutation updateQuote(
    $id: Int!
    $updateQuoteInput: UpdateQuoteInput!
    $items: [UpdateQuoteItemWithTasksInput]
  ) {
    updateQuote(
      id: $id
      updateQuoteInput: $updateQuoteInput
      items: $items
    ) {
      id
      subTotal
      tax
      discount
      totalAmount
      quoteStatus
      discountType
      discountValue
      discountReason
      isDiscountApproved
      paymentTerms
      approvalDate
      status
      notes
    }
  }
`;

export const REMOVE_QUOTE_ITEM_BY_ID = gql`
  mutation removeQuoteItem($id: Int!) {
    removeQuoteItem(id: $id)
  }
`;

export const REMOVE_QUOTE_ATTACHMENT_BY_ID = gql`
  mutation removeQuoteAttachment($id: Int!) {
    removeQuoteAttachment(id: $id)
  }
`;

export const SAVE_WORK_ORDER = gql`
  mutation saveWorkOrder($saveWorkOrder: CreateWorkOrderInput!) {
    saveWorkOrder(saveWorkOrder: $saveWorkOrder)
  }
`;

export const CREATE_QUOTE_PROJECT = gql`
  mutation createQuoteProject($id: Int!) {
    createQuoteProject(id: $id)
  }
`;

export const GENERATE_QUOTE_PDF = gql`
  mutation generateQuotePdf($quoteId: Int!) {
    generateQuotePdf(quoteId: $quoteId) 
  }
`;

export const REVISION_QUOTATION = gql`
  mutation reviseQuote($id: Int!) {
    reviseQuote(id: $id) {
      id
      quoteCode
      version
      quoteStatus
      projectName
      branchId
      leadId
      customerId
      createdAt
      notes
    }
  }
`;

export const ACCEPT_QUOTATION = gql`
  mutation acceptQuote($id: Int!) {
    acceptQuote(id: $id)  {
    id
  }
  }
`;

export const APPROVE_QUOTATION = gql`
  mutation approveQuote($id: Int!) {
    approveQuote(id: $id)  {
    id
  }
  }
`;

export const REVISE_QUOTATION = gql`
  mutation reviseQuoteVariation($parentQuoteId: Int!, $quoteId: Int!) {
    reviseQuoteVariation(parentQuoteId: $parentQuoteId, quoteId: $quoteId) {
      id
      parentQuoteId
      quoteCode
      partnerId
      partnerData {
        id
        partnerType
        customerType
        displayName
        paymentTerm
        companyName
        email
        phone
        mobile
        currency
        emirateID
        openingBalance
        paymentStatus
        status
        primaryContactId
      }
      TRN
      SOW
      quoteDate
      expiryDate
      approvalDate
      createdBy
      createdByData {
        id
        employeeCode
        firstName
        lastName
        middleName
        dateOfBirth
        gender
        email
        phoneNumber
        alternatePhoneNumber
        address
        permanentAddress
        dateOfJoining
        employmentType
        employeeType
        employeeStatus
        profilePicture
        maritalStatus
        nationality
        passportNumber
        visaType
        visaIssueDate
        visaExpiryDate
        salary
        bankName
        bankAccountNumber
        IFSCCode
        reportingManagerId
        status
      }
      branchId
      branchData {
        id
        branchName
      }
      billingAddressId
      billingAddressData {
        id
        partnerId
        attention
        addressType
        addressLine1
        addressLine2
        city
        state
        country
        pinCode
        phone
        fax
      }
      shippingAddressId
      shippingAddressData {
        id
        partnerId
        attention
        addressType
        addressLine1
        addressLine2
        city
        state
        country
        pinCode
        phone
        fax
      }
      refNumber
      projectId
      projectData {
        id
        projectCode
        projectName
      }
      quoteTitle
      subTotal
      tax
      adjustment
      totalAmount
      paymentTerm
      deliveryTerm
      validity
      termsCondition
      customerNote
      additionalNote
      quoteUrl
      status
      createdAt
      updatedAt
      deletedAt
      quoteAttachment {
        id
        quoteId
        fileName
        fileUrl
      }
      quoteItems {
        id
        quoteId
        description
        quantity
        unit
        rate
        amount
        discount
        createdAt
        updatedAt
        deletedAt
      }
      quoteExclusions {
        id
        quoteId
        exclusion
        status
      }
      quoteTemplate {
        id
        templateName
        templateSubject
        templateBody
        templateType
      }
      quoteData {
        id
        workOrderStatus
        workOrderNo
        partnerId
        partnerData {
          id
          displayName
        }
        quoteId
        addressId
        addressData {
          id
          addressLine1
          addressLine2
          city
          country
          state
          phone
          pinCode
          fax
        }

        projectId
        projectData {
          id
          projectName
        }
        projectManagerId
        SOW
        clientRef
        commencementDate
        completionDate
        duration
        status
        createdAt
        updatedAt
        workOrderSOWs {
          id
        }
        attachedFiles {
          id
          fileName
          fileUrl
        }
      }
    }
  }
`;

export const REMOVE_PARENT_QUOTE = gql`
  mutation removeParentQuote($id: Int!) {
    removeParentQuote(id: $id)
  }
`;

export const REMOVE_QUOTE_EXCLUSION = gql`
  mutation removeQuoteExclusion($id: Int!) {
    removeQuoteExclusion(id: $id)
  }
`;

export const REMOVE_QUOTE = gql`
  mutation removeQuote($id: Int!) {
    removeQuote(id: $id)
  }
`;
export const CANCEL_VARIATION = gql`
  mutation cancelVariationQuote($quoteId: Float!) {
    cancelVariationQuote(quoteId: $quoteId)
  }
`;

export const CHANGE_IS_EDITABLE = gql`
  mutation changeIsEditable($id: Int!, $isEditable: Boolean!) {
    changeIsEditable(id: $id, isEditable: $isEditable)
  }
`;

export const EDIT_QUOTATION = gql`
  mutation editQuotation($parentQuoteId: Float!, $branchId: Float!) {
    editQuotation(parentQuoteId: $parentQuoteId, branchId: $branchId)
  }
`;

export const UPDATE_PARENT_QUOTE_STATUS = gql`
  mutation updateParentQuoteStatus($id: Int!, $status: String!) {
    updateParentQuoteStatus(id: $id, status: $status) {
      id
      parentCode
      quoteCode
      quoteDate
      partnerId
      projectId
      parentQuoteStatus
      totalAmount
    }
  }
`;

export const QUOTE_MARK_AS_SENT = gql`
  mutation markAsSentQuote(
    $id: Int!
  ) {
    markAsSentQuote(
      id: $id
    ) {
      id
         }
  }
`;

export const REJECT_QUOTE = gql`
  mutation rejectQuote(
    $id: Int!
  ) {
    rejectQuote(
      id: $id
    ) {
      id
         }
  }
`;
